import { Box, Container, Grid } from "@mui/material";
import {
  ElektronickeAdrese,
  Identifikatori,
  InfoOperater,
  Loading,
  Poruka,
  PrimarnaKontaktAdresa,
  PrimarniIdentifikator,
  StatusOperatera,
} from "../../components";
import { FormProvider, useForm } from "react-hook-form";
import { useContext } from "react";
import Adrese from "../../components/UpravljanjePodacima/Polja/Adrese";
import Button from "@mui/material/Button";
import axios from "axios";
import { TIP_INFO_PORUKE } from "../../enums";
import { Context } from "../../context";
import { useMojiPodaci } from "../../hooks";

type Izdavatelj = {
  oznaka: string;
  euSifra: string;
};

type VrstaIdentifikatora = {
  id: number;
  opis: string;
};

type Identifikator = {
  id: number;
  vrstaIdentifikatora: VrstaIdentifikatora;
  drzavaIzdavatelj: Izdavatelj;
  drzavaRezidentnosti: Izdavatelj;
  identifikacijskiBroj: string;
};

type TipElektronickeAdrese = {
  id: number;
  opis?: string;
};

type ElektronickaAdresa = {
  adresa: string;
  tip: TipElektronickeAdrese;
};

type Drzava = {
  naziv?: string;
  oznaka: string;
  euSifra: string;
};

type Adresa = {
  drzava: Drzava;
  mjesto: string;
  regija?: string;
  postanskiBroj?: string;
  okrug?: string;
  ulica?: string;
  kucniBroj?: string;
};

type Naziv = {
  id: number;
  naziv: string;
};

export type Operater = {
  id: number;
  primarniIdentifikator: Identifikator[];
  registracijskiBroj: string;
  adrese: Adresa[];
  elektronickeAdrese?: ElektronickaAdresa[];
  naziv: Naziv;
  drzava: Drzava;
  identifikator?: Identifikator[];
};

interface FormValues {
  operaterPlatforme: Operater;
  drzave: Drzava[];
  elektronickeAdrese: TipElektronickeAdrese[];
  identifikatori: Identifikator[];
  loading: boolean;
  infoPoruka: string;
  tipInfoPoruke: number | null;
}

const Index = () => {
  const methods = useForm<FormValues>({
    defaultValues: {
      operaterPlatforme: {},
      drzave: [],
      identifikatori: [],
      loading: true,
      infoPoruka: "",
      tipInfoPoruke: null,
    },
  });
  const [data] = useContext(Context);
  const { token } = data;
  const watchAll = methods.watch();

  const { operaterPlatforme, drzave } = useMojiPodaci(methods);

  const onSubmit = async (data: any) => {
    delete data.drzave;
    delete data.elektronickeAdrese;
    delete data.operaterPlatformeModel;
    delete data.identifikatori;

    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/operateri`,
        { ...data },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        methods.setValue("infoPoruka", response.data.message);
        methods.setValue("tipInfoPoruke", TIP_INFO_PORUKE.SUCCESS);
      }
    } catch (error: any) {
      const { status } = error.response;
      if (status === 400) {
        if (error.response.data.errors) {
          error.response.data.errors.forEach((error: any) =>
            methods.setError(error.fieldName, { message: error.error })
          );
        }
      }
    }
  };

  if (!operaterPlatforme || operaterPlatforme.length <= 0 || !drzave)
    return null;

  return (
    <FormProvider {...methods}>
      <Container>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              component={"form"}
              onSubmit={(e) => {
                methods.clearErrors();
                methods.handleSubmit(onSubmit)(e);
              }}
            >
              <InfoOperater />
              <PrimarniIdentifikator />
              <Identifikatori
                nazivPolja={`operaterPlatforme.ostaliIdentifikatori`}
              />
              <Adrese nazivPolja={"operaterPlatforme.adrese"} />
              <PrimarnaKontaktAdresa
                nazivPolja={"operaterPlatforme.primarnaKontaktAdresa"}
                props={{ disabled: true }}
              />
              <ElektronickeAdrese
                nazivOdjeljka={"operaterPlatforme.elektronickeAdrese"}
              />
              <StatusOperatera />
              <Grid container justifyContent={"flex-end"} sx={{ mt: 3 }}>
                <Button variant={"contained"} type={"submit"}>
                  Spremi promjene (Save changes)
                </Button>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Loading />
      <Poruka />
    </FormProvider>
  );
};

export default Index;
